



































import { Component, Vue } from 'vue-property-decorator';
import FilterButtonComponent from '@/components/ToolsBar/ButtonsPanel/FilterButtonComponent.vue';
import LayoutSwitchButtonComponent
  from '@/components/ToolsBar/ButtonsPanel/LayoutSwitchButtonComponent.vue';
import { BaseGetter, FilterGetter, SearchGetter } from '@/store/getters';
import SupportedLayout from '@/types/SupportedLayout';
import { FilterAction } from '@/store/actions';

@Component({
  name: 'buttons-panel-component',
  components: { FilterButtonComponent, LayoutSwitchButtonComponent },
})
export default class ButtonsPanelComponent extends Vue {
  private get isFilterButtonVisible(): boolean {
    return this.$store.getters[FilterGetter.DisplayFilters]
      && this.$store.getters[FilterGetter.Filters].size > 0;
  }

  private get layoutTypes(): Array<SupportedLayout> {
    return this.$store.getters[BaseGetter.LayoutTypes];
  }

  private get isLayoutSwitchVisible(): boolean {
    return this.$store.getters[BaseGetter.IsLayoutSwitchVisible];
  }

  private get totalResults(): number {
    return this.$store.getters[SearchGetter.TotalNumberOfResults];
  }

  private openSideBar() {
    this.$store.dispatch(FilterAction.SetSideBarVisibility, { isOpen: true });
  }
}
